export const shadows = {
  sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  base: "0 0.0625rem 0.1875rem 0 rgb(0 0 0 / 0.1), 0 0.0625 0.125rem 0 rgb(0 0 0 / 0.06)",
  md: "0 0.25rem 0.375rem 0 rgb(0 0 0 / 0.1), 0 0.125rem 0.25rem 0 rgb(0 0 0 / 0.06)",
  lg: "0 0.625rem 0.9375rem 0 rgb(0 0 0 / 0.1), 0 0.25rem 0.375rem 0 rgb(0 0 0 / 0.05)",
  xl: "0 1.25rem 1.5625rem 0 rgb(0 0 0 / 0.1), 0 0.625rem 0.625rem 0 rgb(0 0 0 / 0.04)",
  xxl: "0 1.5625 3.125 0 rgb(0 0 0 / 0.25)",
};
